<template>
  <div class="registration-2__success">
    <p class="registration-2__success-msg">
      <big>Em breve, você poderá receber os pacientes que utilizam o nosso aplicativo Dr. Conecta.</big><br>
      Por isso, indique agora os melhores dias e horários para recebê-los.
    </p>

    <button
      @click="$router.push({path: '../'+officeId+'/doctor-office/agenda/appointment_interval'})"
      :disabled="!officeId"
      class="btn btn-primary"
    >
      Avançar
    </button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      officeId: null
    }
  },
  mounted () {
    this.$http.get('/doctor', this.$store.getters.getAuthHeader).then(
      (res) => {
        this.fn_HIDE_PROGRESS()
        this.officeId = res.data.doctor_offices[0].id
      }
    )
  },
  beforeDestroy () {
    // console.log('precisa logarou')
  }
}
</script>
